function getCookieByName(cookieName: string) {
  if (typeof window === "undefined") {
    return undefined;
  }

  var match = document.cookie.match(
    new RegExp("(^| )" + cookieName + "=([^;]+)")
  );

  if (match) {
    return match[2];
  } else {
    return undefined;
  }
}

export default getCookieByName;
